<template>
  <div class="course-detail-page">
    <!-- 顶部导航 -->
    <van-nav-bar
      title="课程详情"
      left-text="返回"
      left-arrow
      @click-left="onClickLeft"
      fixed
      placeholder
    />

    <!-- 加载状态 -->
    <van-loading v-if="loading" type="spinner" style="margin-top: 100px" />

    <!-- 错误状态 -->
    <van-empty v-else-if="hasError" :description="errorMessage" />

    <!-- 主要内容 -->
    <div v-else class="container">
      <!-- 课程头部信息卡片 -->
      <div class="card course-header">
        <div class="course-title">{{ courseData.title || "暂无课程名称" }}</div>

        <div v-if="courseData.cost" class="course-price">
          ¥{{ courseData.cost }}<span class="price-unit">/节</span>
        </div>

        <div class="course-tags">
          <van-tag v-if="courseData.area" plain type="primary" size="medium">
            区域：{{ courseData.area }}
          </van-tag>
          <van-tag v-if="courseData.grade" plain type="success" size="medium">
            适合年级：{{ courseData.grade }}
          </van-tag>
        </div>

        <div class="info-list">
          <div v-if="courseData.classroom_location" class="info-item">
            <span class="info-label">上课地点：</span>
            <span class="info-value">{{ courseData.classroom_location }}</span>
          </div>
          <div v-if="courseData.create_at" class="info-item">
            <span class="info-label">发布时间：</span>
            <span class="info-value">{{ courseData.create_at }}</span>
          </div>
        </div>
      </div>

      <!-- 课程分类信息卡片 -->
      <div
        v-if="courseData.basic_type_one || courseData.basic_type_two"
        class="card course-category"
      >
        <div
          v-if="courseData.course_type !== null && courseData.course_type !== undefined"
          class="category-item"
        >
          <span class="category-label">课程类型：</span>
          <span class="category-value">{{
            courseTypeMap[courseData.course_type] || "未知类型"
          }}</span>
        </div>
      </div>

      <!-- 课程徽章 -->
      <div
        v-if="courseData.badge_url && courseData.badge_url !== '/images/no_cover.png'"
        class="card badge-section"
      >
        <div class="section-title">课程徽章</div>
        <img
          :src="courseData.badge_url"
          class="badge-image"
          mode="aspectFit"
          alt="课程徽章"
        />
      </div>

      <!-- 课程口号 -->
      <div v-if="courseData.slogan" class="card slogan-section">
        <div class="section-title">课程口号</div>
        <div class="slogan-text">{{ courseData.slogan }}</div>
      </div>

      <!-- 课程内容部分 (富文本) -->
      <div class="card content-section">
        <div v-if="courseData.course_introduction" class="section-item">
          <div class="section-title">课程介绍</div>
          <div class="rich-text-content" v-html="courseData.course_introduction"></div>
        </div>

        <div v-if="courseData.course_charter" class="section-item">
          <div class="section-title">课程章程</div>
          <div class="rich-text-content" v-html="courseData.course_charter"></div>
        </div>

        <div v-if="courseData.course_target" class="section-item">
          <div class="section-title">课程目标</div>
          <div class="rich-text-content" v-html="courseData.course_target"></div>
        </div>
      </div>

      <!-- 底部占位，防止内容被遮挡 (如果有底部固定按钮可在此处添加) -->
      <div style="height: 40px"></div>
    </div>
  </div>
</template>

<script>
import { onMounted, ref } from "vue";
import { Toast } from "vant";
import { useRoute, useRouter } from "vue-router";
import api from "../service/api";

export default {
  setup() {
    const show = ref(false);
    const loading = ref(true);
    const Route = useRoute();
    const router = useRouter();
    const enrollment_id = ref("");
    const detail = ref({});

    // 状态定义
    const hasError = ref(false);
    const errorMessage = ref("");

    const courseData = ref({
      id: "0",
      institution_id: "0",
      school_id: 0,
      course_type: 0,
      title: "",
      basic_type_one: 0,
      basic_type_two: 0,
      class_hour: "",
      cost: "",
      area: "",
      slogan: "",
      badge_url: "",
      course_introduction: "",
      course_charter: "",
      course_target: "",
      grade: "",
      classroom_location: "",
      create_at: "",
      isRegistered: 0,
      courseId: 0,
    });

    // 课程类型映射      1: "机构课程",

    const courseTypeMap = {
      1: "校内课程",
      2: "校内课程",
      3: "特色课程",
    };

    const onClickLeft = () => {
      router.go(-1);
    };

    // 加载课程详情
    const loadCourseDetail = (courseId) => {
      loading.value = true;
      hasError.value = false;

      api
        .getCourseDetail({
          course_id: courseId,
        })
        .then((res) => {
          console.log("API Response:", res);
          // 假设后端返回结构为 res.data.code
          if (res.data && res.data.code === 1001) {
            const data = res.data.result;
            // 合并数据，确保默认值不被清空（可选，视需求而定）
            courseData.value = { ...courseData.value, ...data };
          } else {
            const msg = res.data?.message || "获取课程详情失败";
            Toast.fail(msg);
            hasError.value = true;
            errorMessage.value = msg;
          }
        })
        .catch((err) => {
          console.error(err);
          const msg = err.message || "网络请求错误";
          Toast.fail(msg);
          hasError.value = true;
          errorMessage.value = msg;
        })
        .finally(() => {
          loading.value = false;
        });
    };

    onMounted(() => {
      enrollment_id.value = Route.query.id || Route.query.enrollment_id;
      if (enrollment_id.value) {
        loadCourseDetail(enrollment_id.value);
      } else {
        loading.value = false;
        hasError.value = true;
        errorMessage.value = "缺少课程ID参数";
        Toast.fail("缺少课程ID");
      }
    });

    return {
      show,
      loading,
      detail,
      onClickLeft,
      enrollment_id,
      courseTypeMap,
      courseData,
      loadCourseDetail,
      hasError,

      errorMessage,
    };
  },
};
</script>

<style lang="less" scoped>
.course-detail-page {
  background-color: #f5f5f5;
  min-height: 100vh;
}

.container {
  padding: 12px; // 对应小程序 20rpx
}

/* 通用卡片样式 */
.card {
  background: #fff;
  border-radius: 16px;
  padding: 24px; // 对应小程序 30rpx
  margin-bottom: 16px; // 对应小程序 20rpx
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
}

/* 课程头部 */
.course-header {
  .course-title {
    font-size: 18px; // 对应 36rpx
    font-weight: bold;
    color: #333;
    line-height: 1.4;
    margin-bottom: 12px;
  }

  .course-price {
    font-size: 15px; // 对应 30rpx
    font-weight: bold;
    color: #ff6b35;
    margin-bottom: 12px;

    .price-unit {
      font-size: 12px;
      font-weight: normal;
      margin-left: 4px;
    }
  }

  .course-tags {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    margin-bottom: 12px;
  }

  .info-list {
    .info-item {
      display: flex;
      align-items: flex-start;
      margin-bottom: 8px;
      font-size: 14px; // 对应 28rpx

      &:last-child {
        margin-bottom: 0;
      }

      .info-label {
        color: #666;
        width: 80px; // 对应 160rpx (按比例缩小)
        flex-shrink: 0;
        line-height: 1.5;
      }

      .info-value {
        color: #333;
        flex: 1;
        line-height: 1.5;
      }
    }
  }
}

/* 课程分类 */
.course-category {
  .category-item {
    font-size: 14px;
    margin-bottom: 8px;

    .category-label {
      color: #666;
      margin-right: 8px;
    }

    .category-value {
      color: #333;
      font-weight: 500;
    }
  }
}

/* 章节标题通用 */
.section-title {
  font-size: 15px;
  font-weight: bold;
  color: #333;
  margin-bottom: 12px;
  display: block;
  border-left: 4px solid var(--color-primary); /* 增加一点视觉引导 */
  padding-left: 8px;
}

/* 徽章 */
.badge-section {
  text-align: center;

  .badge-image {
    width: 50px; // 对应 100rpx
    height: 50px;
    border-radius: 6px;
    object-fit: contain;
  }
}

/* 口号 */
.slogan-section {
  .slogan-text {
    font-size: 14px;
    color: #666;
    background: #f8f9fa;
    padding: 10px;
    border-radius: 4px;
    line-height: 1.5;
    text-align: left;
  }
}

/* 富文本内容 */
.content-section {
  .section-item {
    margin-bottom: 16px;

    &:last-child {
      margin-bottom: 0;
    }

    /* 深度选择器处理 v-html 内部样式 */
    :deep(.rich-text-content) {
      font-size: 14px;
      line-height: 1.6;
      color: #333;

      p {
        margin-bottom: 8px;
        &:last-child {
          margin-bottom: 0;
        }
      }

      img {
        max-width: 100%;
        height: auto;
        display: block;
        margin: 10px 0;
      }
    }
  }
}
</style>
